<template>
	<div class="home">
		<div class="bg-container">
			<video muted autoplay loop>
				<source src="/media/home_bg.mp4" type="video/mp4">
			</video>
		</div>

		<div class="overlay">
			<div class="container mt-header">
				<div class="row text-start">
					<div class="col-12 mt-5">
						<h1>Hourglass land</h1>
						<h1>NFT Mint</h1>
						<h2>(coming soon)</h2>
					</div>

					<div class="col-12 my-5">
						<h3>Register your interest for an Hourglass whitelist spot.</h3>

						<router-link to="/signup" class="btn btn-primary btn-lg px-5 mt-5">Sign Up</router-link>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'HomeView',
	components: {}
}
</script>

<style scoped>
.bg-container {
	position: absolute;
	right: 0;
	top: 0;
	width: 100%;
	height: 100vh;
	overflow: hidden;
	z-index: 0;
}

.overlay {
	position: absolute;
	top: 0;
	right: 0;
	width: 100%;
	height: 100%;
}

.bg-container video {
	max-width: 100%;
	min-height: 100%;
}

h1 {
	font-size: 72px;
	font-weight: bolder;
	background: -webkit-linear-gradient(#00CB79, #3793FF);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
}

.btn.btn-primary {
	transition: all 0.3s ease;
}

.btn.btn-primary:hover {
	transform: scale(1.2);
}

h2 {
	color: white;
}

h3 {
	color: white;
	font-size: 1.4rem;
	font-weight: normal;
}
</style>
